import axios from "axios"
import humps from "humps"
import { scrollToTop } from 'servos/formHelpers'

// We don't want to camelize the _destroy key when passed as rails
// relies on it when we want to destroy an object.
// ei. I mark a commitment for destruction and at the same time I add a new invalid commit.
// After server returns 422 want to:
// - display error
// - the commitment marked for destruction must be hidden
// - the commitment marked for destruction must still HOLD the _destroy attribute
const camelizeData = (data) => {
  return humps.camelizeKeys(data, function(key, convert) {
    return /_destroy/.test(key) ? key : convert(key)
  } )
}

export const putRequest = ({ url, data, onSuccess, onFailure }) => {
  return axios.put(url, humps.decamelizeKeys(data))
    .then(response => ( onSuccess(camelizeData(response)) ))
    .catch(error => (
      scrollToTop(),
      onFailure(camelizeData(error))
    ))
}

export const postRequest = ({ url, data, onSuccess, onFailure }) => {
  return axios.post(url, humps.decamelizeKeys(data))
    .then(response => ( onSuccess(camelizeData(response)) ))
    .catch(error => (
      scrollToTop(),
      onFailure(camelizeData(error))
    ))
}

export const getRequest = ({ url, onSuccess, onFailure }) => {
  return axios.get(url)
    .then(response => ( onSuccess(camelizeData(response)) ))
    .catch(error => ( onFailure(camelizeData(error)) ))
}
